import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateShowCurrentTrackerResponse } from '../../../types';
import { AFFILIATE_CURRENT_TRACKER_API_URL, AFFILIATE_CURRENT_TRACKER_QUERY } from '../constants';

export default function useAffiliateShowCurrentTrackerQuery(id: Ref<number>, trackerId: Ref<number>): IContextQueryResult<
  IAffiliateShowCurrentTrackerResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateShowCurrentTrackerResponse>({
    queryKey: [AFFILIATE_CURRENT_TRACKER_QUERY, id, trackerId],
    queryFn: ({ signal }) => fetchGet<IAffiliateShowCurrentTrackerResponse>(
      AFFILIATE_CURRENT_TRACKER_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
          trackerId: trackerId.value,
        },
      },
    ),
    enabled: computed(() => !!id.value && !!trackerId.value),
  });
}
